<template>
  <SeoLinks v-if="seoLinksList" class="my-32 md:my-72" :links="seoLinksList" />
</template>

<script setup lang="ts">
import { useRequestURL } from '#imports'
import { computed } from 'vue'

import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { uniqBy } from '@backmarket/utils/collection/uniqBy'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

import SeoLinks from '~/scopes/product-core/components/presentationals/SeoLinks/SeoLinks.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useMasterPP } from '~/scopes/product-core/composables/useMasterPP/useMasterPP'
import type { LinkBooster } from '~~/shared/api/internal-links/types'

import { useFetchLinkBooster } from './composables/useFetchLinkBooster/useFetchLinkBooster'
import { useFetchSiblings } from './composables/useFetchSiblings/useFetchSiblings'

const { data: siblings } = useFetchSiblings()
const { data: linkBoosters } = useFetchLinkBooster()
const { isMasterPPUrl } = useMasterPP()
const { data: productResponse } = useFetchProduct()
const locale = useI18nLocale()
const { origin } = useRequestURL()

const masterPDPUrl = computed(() => {
  if (isMasterPPUrl.value) {
    return null
  }

  return {
    title: productResponse.value?.titles.default,
    relativeLink: new URL(
      `/${toBcp47Locale(locale)}/p/${productResponse.value?.parentProductSlug}`,
      origin,
    ).href,
  }
})

const seoLinksList = computed(() =>
  uniqBy(
    [
      ...(siblings.value || []),
      masterPDPUrl.value,
      ...(linkBoosters.value || []),
    ].filter(Boolean) as LinkBooster[],
    'title',
  ),
)
</script>
